import { patchState, signalStore, type, withComputed, withHooks, withMethods } from '@ngrx/signals';
import { setAllEntities, setEntity, withEntities } from '@ngrx/signals/entities';
import { OrganizationFeatures, OrganizationSummary, OrganizationTypes } from '@twist/backbone-api-services/ciam';
import { setError, setLoaded, setLoading, withCallState } from '@twist/core';
import { inject } from '@angular/core';
import { OrganizationManagementService } from '../services/organization-management.service';

export const OrganizationsStore = signalStore(
  withCallState(),
  withEntities({ entity: type<OrganizationSummary>(), collection: 'organizations' }),
  withComputed(state => {
    return {};
  }),
  withMethods(state => {
    const organizationsService = inject(OrganizationManagementService);
    const initialize = async () => {
      patchState(state, setLoading());
      try {
        const allOrganizations = await organizationsService.getOrganizations();
        patchState(state, setLoaded());
        if (allOrganizations?.results) {
          patchState(state, setAllEntities(allOrganizations?.results, {
            collection: 'organizations',
            selectId: x => x.key
          }));
        }
      } catch (error) {
        patchState(state, setError('Failed to load organizations'));
      }
    };

    const createOrganization = async (name: string,
                                      features: Array<OrganizationFeatures>): Promise<OrganizationSummary> => {
      const organization = await organizationsService.createOrganization(
        {
          name: name,
          organizationType: OrganizationTypes.TwistPartner,
          enabledFeatures: features
        });

      if (organization){
        patchState(state, setEntity(organization as OrganizationSummary, { collection: 'organizations', selectId: x => x.key }));
      }

      return organization;
    };


    return {
      initialize,
      createOrganization
    };
  }),
  withHooks({
    onInit(state) {
      state.initialize();
    }
  })
);
